/**
 * Using a very minimal custom Root for now so we can work out the specifics we need with the home team on the header.
 * The zion Root is much larger and has various data fetching that we don't want and will not work on ident subdomains.
 * We can follow up with the frontier team if we can create some type of minimal Root component that we can use like this.
 * This current version would not pull in any outage banner for instance but otherwise should be fully functional for our needs.
 */
import React, { useEffect } from 'react'
import ErrorBoundary from '@fs/zion-error-boundary'
import Experiments from '@fs/zion-experiments'
import { I18nProvider } from '@fs/zion-locale'
import { Providers, Theme } from '@fs/zion-ui'
import { FlagOverrides } from '@fs/zion-flags'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Header2019 } from '@fs/zion-header'

const rootCss = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`
const mainCss = css`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 0;
`
const defaultHeaderProps = {
  signedIn: false,
  useBaseUrl: true,
  showMobileDrawer: false,
  showNavLinksDesktop: false,
  showFHCLocations: false,
  showHelpOverlay: false,
  showUserOrAuth: false,
}
export default function Root({ children, theme = 'day', analytics = false, header = {} }) {
  const [t] = useTranslation()

  useEffect(() => {
    if (analytics) {
      // lazy-load tealium, only if analytics are set `true` in Root props
      import('@fs/zion-analytics').then(({ loadAnalytics }) => loadAnalytics())
    }
  }, [analytics])

  return (
    <ErrorBoundary>
      <Theme theme={theme}>
        <I18nProvider>
          <Providers>
            <div css={rootCss}>
              <Experiments />
              <FlagOverrides />
              {!header.hidden && <Header2019 {...{ ...defaultHeaderProps, ...header }} />}
              <main css={mainCss} id="main" aria-label={t('root.main.content', 'Main Content')}>
                {children}
              </main>
            </div>
          </Providers>
        </I18nProvider>
      </Theme>
    </ErrorBoundary>
  )
}
